import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';

import logo from '../../../Assets/image/logo.jpg';

function Intro({
  loading,  
  companies,
  selectedCompany,
  handleCompanyChange,
}) {
  const handleChange = (ev) => {
    sessionStorage.setItem('company_org_id', ev.target.value);
    handleCompanyChange(ev.target.value);
  };

  return (
    <div
      style={{
        height: '89vh',
        overflowY: 'hidden',
        overflowX: 'hidden',
      }}
    >
      <div id="intro">
        <FormControl variant="standard">
          <Select
            value={
              companies.length > 0
                ? companies.find((company) => company.id === selectedCompany)
                  ? companies.find(
                      (company) => company.id === selectedCompany,
                    ).id
                  : ''
                : ''
            }
            onChange={handleChange}
            sx={{
              '& .MuiSelect-root': {
                height: 33,
                paddingTop: 0,
                paddingBottom: 0,
                display: 'flex',
                alignItems: 'center',
                fontSize: '11pt',
                fontFamily: 'Verdana !important',
                fontWeight: 'bold',
              },
            }}
            disabled={loading}
          >
            {companies &&
              companies.map(
                (cur) =>
                  cur.IsActive && (
                    <MenuItem key={cur.id} value={cur.id}>
                      {cur.CompanyName}
                    </MenuItem>
                  ),
              )}
          </Select>
        </FormControl>
      </div>
      <div id="logo">
        <div
          className="column col-xs-6"
          id="zoomIn"
          style={{ width: '100%' }}
        >
          <img
            src={logo}
            style={{ width: '100%', height: '100%' }}
            className="img-fluid"
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

Intro.propTypes = {
  loading: PropTypes.bool.isRequired,  
  companies: PropTypes.array.isRequired,
  selectedCompany: PropTypes.number.isRequired,
  handleCompanyChange: PropTypes.func.isRequired,
};

export default Intro;
